// @ts-nocheck
import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { Button } from 'antd';
import Tools, { config } from '../../utils/tools';
import JsonRequest from '../../components/jsonRequest';

interface WechatOpenAppButtonProps {
    style?: React.CSSProperties;
    buttonText?: string;
}

// 定义 ref 可以调用的方法类型
export interface WechatOpenAppButtonRef {
    triggerAppLaunch: () => void;
}

const WechatOpenAppButton = forwardRef<WechatOpenAppButtonRef, WechatOpenAppButtonProps>(({
    style,
    buttonText = 'App内打开'
}, ref) => {
    const openBtn = useRef<any>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    // 暴露给父组件调用的方法
    useImperativeHandle(ref, () => ({
        triggerAppLaunch: () => {
            if (buttonRef.current) {
                buttonRef.current.click();
            }
        }
    }));

    useEffect(() => {
        if (Tools.isWechat() && window.wx) {
            JsonRequest.rawClient().get(`/common/wechat-web-evoke-app`, {
                url: window.location.href.split('#')[0]
            })
                .then((resp: any) => resp.json())
                .then(async ({ data }: any) => {
                    window.wx.config({
                        ...data,
                        jsApiList: [],
                        openTagList: ['wx-open-launch-app']
                    });

                    const launchFunc = function () {
                        Tools.copy(window.location.href);
                    };

                    const errFunc = function (err: any) {
                        if (Tools.isIOS()) {
                            window.location.href = config.appStoreUrl;
                            alert("您还没有安装知源把脉养生或者版本需要升级");
                        } else if (Tools.isAndroid()) {
                            alert("您还没有安装知源把脉养生或者版本需要升级，请点击右上角菜单，选择「在浏览器中打开」下载App");
                        }
                        Tools.copy(window.location.href);
                    };

                    openBtn.current?.addEventListener("launch", launchFunc);
                    openBtn.current?.addEventListener("error", errFunc);

                    return () => {
                        openBtn.current?.removeEventListener("launch", launchFunc);
                        openBtn.current?.removeEventListener("error", errFunc);
                    };
                });
        }
    }, [openBtn]);

    if (Tools.isAndroid() || Tools.isIOS()) {
        if (Tools.isWechat()) {
            return (
                <wx-open-launch-app id="wechat-launch-btn" ref={openBtn} appid="wx2b793e06bf0b460e">
                    <script type="text/wxtag-template">
                        <button style={style} ref={buttonRef}>
                            {buttonText}
                        </button>
                    </script>
                </wx-open-launch-app>
            );
        } else {
            return (
                <button
                    style={style}
                    onClick={Tools.handleAppDownload}
                    ref={buttonRef}
                >
                    {buttonText}
                </button>
            );
        }
    } else {
        return (
            <Button
                style={style}
                onClick={() => window.open(config.fallbackWebUrl, '_blank', 'noopener,noreferrer')}
                ref={buttonRef}
            >
                {buttonText}
            </Button>
        );
    }
});

export default WechatOpenAppButton;